function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#FF5959",
  fillRule: "nonzero"
}), React.createElement("text", {
  fill: "#FFF",
  fontFamily: "AvertaPE-Bold, Averta PE",
  fontSize: 14,
  fontWeight: "bold"
}, React.createElement("tspan", {
  x: 5.71428571,
  y: 13
}, "!")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/warning.71232ede.svg";
export { SvgComponent as ReactComponent };